<div class="footer">
    <p>HYFLY TAXIS © 2023. All Rights Reserved.</p>
</div>